import React, { useEffect, useRef, useState } from "react";
import { StyleSheet, css } from "aphrodite";
import ManateeLoading from "../ManateeLoading";

const textVariants = [
  "Finishing up your account...",
  "Checking our calendars...",
  "Choosing your Care Coordinator...",
  "Almost there, hang tight!"
];

type Props = {
  onTextRotation: () => void;
  afterLastTextShown: () => void;
};

export default function ConsultLoading({ onTextRotation }: Props) {
  const [textIndex, setTextIndex] = useState(0);
  const intervalMillis = useRef<number>(3000);

  useEffect(() => {
    const interval = setInterval(() => {
      if (onTextRotation) {
        onTextRotation();
      }
      setTextIndex(index => {
        if (index < textVariants.length - 1) {
          return index + 1;
        }
        intervalMillis.current = 500;
        return index;
      });
    }, intervalMillis.current);

    return () => {
      clearInterval(interval);
    };
  }, [onTextRotation]);

  return (
    <div className={css(styles.container)}>
      <ManateeLoading disableShadow />
      <div className={css(styles.textContainer)}>
        <p className={css(styles.text)}>{textVariants[textIndex]}</p>
      </div>
    </div>
  );
}

const styles = StyleSheet.create({
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#FFFFFF",
    paddingBottom: 20,
    paddingRight: "3%",
    paddingLeft: "3%",
    boxShadow: "4px 4px 23px -6px rgba(0, 0, 0, 0.25)"
  },
  textContainer: {
    paddingBottom: 20
  },
  text: {
    fontWeight: 700,
    color: "#1A2579",
    fontSize: 20
  }
});
